var map = {
	"./PC-bg.png": "0b6b",
	"./allClassify.png": "0598",
	"./allSprites.png": "dd10",
	"./arrow.png": "5a8f",
	"./avater.png": "54a5",
	"./axis.png": "8404",
	"./bg-top.png": "b2c0",
	"./bg.png": "dc97",
	"./bmp.png": "8bcb",
	"./cunw.png": "3579",
	"./defaultSchool.png": "b39c",
	"./doc.png": "fa64",
	"./help-bg.png": "3c44",
	"./help-searh.png": "3395",
	"./honer_sys.png": "185b",
	"./hot.png": "60b1",
	"./icon-search.png": "793a",
	"./icon1.png": "ded3",
	"./icon1H.png": "e9ed",
	"./icon2.png": "e82b",
	"./icon2H.png": "3f1e",
	"./icon3.png": "b23c",
	"./icon3H.png": "1c9e",
	"./icon4H.png": "2032",
	"./icon5H.png": "0630",
	"./icon6H.png": "2d7b",
	"./icon7H.png": "7844",
	"./icon8H.png": "a881",
	"./icon9H.png": "2af7",
	"./ing.png": "0118",
	"./inset.png": "41c3",
	"./kitchenware_icon.png": "eb2c",
	"./koi_nmg_xxlogo.png": "c204",
	"./login-h5bg.png": "2c1e",
	"./login-logo.png": "712a",
	"./logo-new.59a73b97.png": "6536",
	"./logo.png": "4ffd",
	"./moreIcon.png": "d3fe",
	"./moren.png": "dd46",
	"./mp3.png": "7ef0",
	"./msg.png": "26c9",
	"./msg1.png": "c4a3",
	"./msg2.png": "912e",
	"./msg3.png": "c8e0",
	"./no-star.png": "3e8e",
	"./oaBack_sys.png": "b17e",
	"./oaUser_sys.png": "05a5",
	"./ok-star.png": "ce9a",
	"./other.png": "01ac",
	"./perIcon.png": "09c7",
	"./pic.png": "b964",
	"./platform-connect/banner1.png": "c5f8",
	"./platform-connect/koi_nmg_xclogo.png": "de67",
	"./platform-connect/koi_nmg_xxlogo.png": "5a88",
	"./platform-connect/location-blue.png": "2070",
	"./platform-connect/location-orign.png": "6e34",
	"./platform-connect/location-red.png": "fff8",
	"./platform-connect/logo-new.59a73b97.png": "49c1",
	"./platform-connect/platform1.png": "3bca",
	"./platform-connect/platform2.png": "6f62",
	"./ppt.png": "6358",
	"./recommend-1-h5.png": "7077",
	"./recommend-1.png": "f234",
	"./recommend-2.png": "3783",
	"./recommend-21-h5.png": "123e",
	"./safeManage_icon.png": "f3a3",
	"./safeSchool_icon.png": "f703",
	"./schoolShield_icon.png": "01cc",
	"./sy1.png": "6420",
	"./sy2.png": "00c6",
	"./sy3.png": "42f1",
	"./sy4.png": "d325",
	"./sy5.png": "c4af",
	"./teacher.png": "47d1",
	"./teacherResearch_sys.png": "1bbf",
	"./tx.png": "568d",
	"./txt.png": "d83f",
	"./u282.png": "273e",
	"./user_icon.png": "d26b",
	"./vector.png": "7308",
	"./vector1.png": "7269",
	"./vector2.png": "09ee",
	"./video.png": "1c04",
	"./xls.png": "b192",
	"./yingyong.png": "25b2",
	"./zip.png": "01d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";